<template>
  <div class="mb-4">
    <h6 class="fw-bold mb-3">
      Expert comptable
    </h6>
    <div class="row">
      <div class="col-12 mb-3">
        <label class="form-label">Numéro d'enregistrement au registre des Experts Comptables</label>
        <input
          v-model="accountantNumber"
          type="text"
          class="form-control"
          :class="
            touchedFields.accountantNumber
              ? `is-${isAccountantNumberValid ? 'valid' : 'invalid'}`
              : ''
          "
          placeholder="Entrez le numéro d'enregistrement"
          @blur="touchedFields.accountantNumber = true"
        >
        <div
          v-if="touchedFields.accountantNumber && !isAccountantNumberValid"
          class="invalid-feedback"
        >
          Le numéro d'enregistrement est requis
        </div>
      </div>
      <div class="col-12 mb-3">
        <label class="form-label">Date d'enregistrement</label>
        <input
          v-model="accountantRegistrationDate"
          type="date"
          class="form-control"
          :class="
            touchedFields.accountantRegistrationDate
              ? `is-${isRegistrationDateValid ? 'valid' : 'invalid'}`
              : ''
          "
          @blur="touchedFields.accountantRegistrationDate = true"
        >
        <div
          v-if="touchedFields.accountantRegistrationDate && !isRegistrationDateValid"
          class="invalid-feedback"
        >
          La date saisie n'est pas valide
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash-es';

export default {
  name: 'ComplementaryAccountantForm',
  props: {
    contract: {
      type: Object,
      required: true,
    },
  },
  emits: ['validation'],
  data() {
    return {
      accountantNumber: '',
      accountantRegistrationDate: '',
      touchedFields: {
        accountantNumber: false,
        accountantRegistrationDate: false,
      },
    };
  },
  computed: {
    isAccountantNumberValid() {
      if (this.accountantNumber.length === 0) return false;
      return this.accountantNumber.trim().length > 0;
    },

    isRegistrationDateValid() {
      if (this.accountantRegistrationDate.length === 0) return false;
      const selectedDate = new Date(this.accountantRegistrationDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      // Date min
      const minDate = new Date('1900-01-01');
      return selectedDate >= minDate && selectedDate <= today;
    },
    hasError() {
      return !(this.isAccountantNumberValid && this.isRegistrationDateValid);
    },
  },
  watch: {
    hasError: {
      immediate: true,
      handler(val) {
        this.$emit('validation', !val);
      },
    },
  },
  mounted() {
    this.accountantNumber = get(this.contract, 'risk.accountantNumber', '');
    this.accountantRegistrationDate = get(this.contract, 'risk.accountantRegistrationDate', '');
  },
  methods: {
    async submit() {
      return {
        accountantNumber: this.accountantNumber,
        accountantRegistrationDate: this.accountantRegistrationDate,
      };
    },
  },
};
</script>
